module.exports = __webpack_public_path__ + "ee8976b95cc018172078026e6b36a4e9.svg";